import o, { useEffect as m } from "react";
import { useTranslation as f } from "react-i18next";
import { KioskTitle as n } from "../../components/KioskTitle/KioskTitle.js";
import { useKioskLanding as c } from "../../context.js";
import { useKioskSchedule as u } from "../../hooks/useKioskSchedule.js";
import s from "./OutOfOrder.module.scss.js";
function E() {
  const { configuration: e, lang: d, restart: a } = c(), { scheduleCompliance: i } = u();
  m(() => {
    i.complies && a();
  }, [i]);
  const { t: r } = f(), l = (e == null ? void 0 : e.disabled.design.images.disabled) || "https://static.cheerfy.com/integration/images/kiosk/outoforder.png", t = e == null ? void 0 : e.disabled.texts[d];
  return /* @__PURE__ */ o.createElement("div", { "data-testid": "out-of-order", className: s.outOfOrder }, /* @__PURE__ */ o.createElement("img", { className: s.outOfOrder__logo, src: l, alt: "out of order" }), /* @__PURE__ */ o.createElement(n, { text: (t == null ? void 0 : t.disabled_title) || r("kioskLanding.outOfOrder.title") }), /* @__PURE__ */ o.createElement("div", { className: s.outOfOrder__subtitle }, (t == null ? void 0 : t.disabled_info) || r("kioskLanding.outOfOrder.subtitle")));
}
export {
  E as OutOfOrder
};
//# sourceMappingURL=OutOfOrder.js.map
